<template>
  <div class="v-stack h-stretch gap-3">
    <template v-if="!minimal">
      <a class="heading-title-2">Gear</a>
      <div class="card light mn">
        <div class="content h-stretch">
          <div class="v-stack h-stretch gap-3" v-if="!loading">
            <div class="v-stack h-stretch v-start gap-3 card py-5">
              <div class="pane-horizontal gap-3">
                <div class="text-right">Owned Gear Cost:</div>
                <div class="text-left">{{ format.currency(gearCost) }} kč</div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Gear Expenses:</div>
                <div class="text-left">
                  {{ format.currency(otherGearCost) }} kč
                </div>
              </div>
              <div class="pane-horizontal gap-3">
                <div class="text-right">Gear Revenue:</div>
                <div class="text-left">
                  {{ format.currency(gearRevenue) }} kč
                </div>
              </div>
              <div class="separator"></div>
              <div class="pane-horizontal gap-3" style="font-weight: bold">
                <div class="text-right">Total:</div>
                <div class="text-left">
                  {{ format.currency(balance) }}
                  kč
                </div>
              </div>
            </div>
          </div>
          <div v-else><span class="loader"></span></div>
        </div>
      </div>
    </template>

    <template v-if="!loading">
      <div
        class="v-stack gap-3 h-stretch"
        v-for="category in categories"
        :key="category.name"
      >
        <div class="h-stack h-start gap-3">
          <a
            class="heading-title-2"
            @click="category.expanded = !category.expanded"
            >{{ category.name }}</a
          >

          <div v-if="category.expanded">&#9660;</div>
          <div v-if="!category.expanded">&#9650;</div>
        </div>
        <Table
          v-if="category.expanded && !minimal"
          :items="items.filter((item) => item.categorySub == category.name)"
          :defaultColumn="0"
          :css="'1fr 60px 120px 120px 160px 80px'"
          v-on:rowSelected="$emit('rowSelected', $event)"
          :columns="[
            {
              name: 'Name',
              sort: 'alphabet',
              path: ['name'],
            },
            {
              name: 'Owned',
              sort: 'numeric',
              path: ['gear', 'length'],
            },
            {
              name: 'Cost',
              sort: 'numeric',
              path: ['gearValue'],
              format: 'czk',
              formatType: 'currency',
            },
            {
              name: 'Revenue',
              sort: 'numeric',
              path: ['gearRevenue'],
              format: 'czk',
              formatType: 'currency',
              formatMap: (price) => Math.round(price),
            },
            {
              name: 'Balance',
              sort: 'alphabet',
              formatMap: (item) => `${item.gearRevenue - item.gearValue}`,
              formatType: 'currency',
              format: 'czk',
            },
            {
              name: '%',
              sort: 'alphabet',
              formatMap: (item) =>
                `${
                  item.gearValue > 0
                    ? Math.round((item.gearRevenue / item.gearValue) * 100)
                    : 0
                }%`,
            },
          ]"
        ></Table>
        <Table
          v-if="category.expanded && minimal"
          :items="items.filter((item) => item.categorySub == category.name)"
          :defaultColumn="0"
          :css="'1fr 60px'"
          v-on:rowSelected="$emit('rowSelected', $event)"
          :columns="[
            {
              name: 'Name',
              sort: 'alphabet',
              path: ['name'],
            },
            {
              name: 'Owned',
              sort: 'numeric',
              path: ['gear', 'length'],
            },
          ]"
        ></Table>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Table from "@/components/Table.vue";
import constants from "@/constants.js";
import utils from "@/utils.js";

export default {
  props: {
    minimal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      gearCost: 0,
      gearRevenue: 0,
      otherGearCost: 0,
      balance: 0,
      categories: constants.pricelistSubCategoriesGear.map((item) => {
        return {
          name: item,
          expanded: true,
        };
      }),
      format: utils.format,
      loading: true,
    };
  },
  components: {
    Table,
  },
  methods: {
    ...mapActions(["getGearOverview"]),
    loadGearData() {
      this.loading = true;
      this.getGearOverview()
        .then((data) => {
          this.items = data.items;
          this.gearCost = data.gearCost;
          this.gearRevenue = data.gearRevenue;
          this.otherGearCost = data.otherGearCost;
          this.balance = data.balance;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadGearData();
  },
};
</script>

<style scoped>
a.heading-title-2 {
  align-self: center;
  padding: 0px;
  user-select: none;
}

.heading-title-2:hover {
  text-decoration: underline;
}
</style>
